<template>
<el-main>
  <div class="container-con">
    <div class="center-aligned success" :class="{disnone: status !== 'success'}">
      <img src="@/assets/img/shop/success.png">
      <h2>Payment succeed</h2>
      <p>please go to your email to receive your merchandises.</p>
      <router-link :to="{ name: 'shop' }">Will return to the homepage of Shop after {{ num }} seconds.</router-link>
    </div>

    <div class="center-aligned failed" :class="{disnone: status !== 'failed'}">
      <img src="@/assets/img/shop/failed.png">
      <h2>Failed to pay</h2>
      <router-link :to="{ name: 'shop' }">Pay again</router-link>
    </div>
  </div>
</el-main>
</template>

<script>
// @ is an alias to /src

export default {
  data () {
    return {
      num: 10,
      status: 'non'
    }
  },
  created () {
    this.status = this.$route.query.callback || 'failed'
  },
  mounted () {
    if(this.$route.query.callback === 'success') {
      let interval = setInterval(() => {
        if (this.num === 0) {
          clearInterval(interval)
          return this.$router.push({ name: 'shop' })
        }
        this.num--
      }, 1000)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.disnone {
  display: none;
}
.container-con .success{
  margin: 180px auto 293px auto;
  h2 {
    font-size: 32px;
    margin-bottom: 20px;
  }
  p {
    font-size: 18px;
    color: #101010;
    margin: 12px 0px;
  }
  a {
    font-size: 18px;
    box-shadow: 0 1px;
  }
}

.container-con .failed{
  margin: 180px auto 281px auto;
  h2 {
    font-size: 38px;
    margin-bottom: 20px;
  }
  a {
    width: 212px;
    height: 48px;
    font-size: 28px;
    background-color: #fff0;
    border: solid 2px #2e2e2e;
    border-radius: 24px;
    font-size: 24px;
    color: #2e2e2e;
    display: inline-block;
    line-height: 48px;
  }
}
</style>
